import { useEffect, useRef } from 'react';
import { useIonRouter } from '@/app/IonicContextProvider';
import { navigationService } from '@/lib/navigation';
import { authService } from '@/lib/auth';

export const useNotificationNavigation = () => {
  const router = useIonRouter();
  const isSetup = useRef(false);

  useEffect(() => {
    // Only set up the callback once to avoid multiple callbacks
    if (!isSetup.current) {
      console.log('Setting up notification navigation callback');
      navigationService.setNavigationCallback(async (path: string) => {
        console.log('Notification navigation callback triggered:', path);

        try {
          // Check if user is authenticated before navigating
          const isAuthenticated = await authService.isSessionValid();
          if (!isAuthenticated) {
            console.log('User not authenticated, ignoring notification navigation');
            return;
          }

          router.push(path);
        } catch (error) {
          console.error('Failed auth check for notification navigation:', error);
        }
      });
      isSetup.current = true;
    }

    // Cleanup function
    return () => {
      console.log('Cleaning up notification navigation callback');
      navigationService.setNavigationCallback(undefined);
      isSetup.current = false;
    };
  }, [router]);
};
